import React from 'react'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import NavWidget from '../../../../widget/Nav/NavWidget'
import HomeByCalendarPageWidget from './homeByCalendarPageWidget'

function Homebycalendar() {
  return (
    <div>
      <NavWidget/>
      <div className='row' >
            <div className='col s12 l2 transparent hide-on-med-and-down'>
                <SidebarWidget/>
            </div>
            <div className='col s12 l10 '
                style={{
                    maxheight:"1300px",
                    overflow: "auto !important",
                }}
            >
                <div className='row p-2'>
                    <div className='col s12 '>
                        <HomeByCalendarPageWidget/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Homebycalendar